import React, { useState } from "react"

const TimeModeRegister = () => {
    const [timeMode, setTimeMode] = useState(null)
    return(
        <React.Fragment>
        TIME MODE
        </React.Fragment>
    )
}

export default TimeModeRegister